/*
 * Module for the Annuity Option Selection step of the Forward DROP Enrollment form
*/
rs.module("ui/content/communications/onlineforms/annuityoption",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var annuityOptionRadio = stepContainer.js(jsSelectors.annuityOptionRadio, { multiple: true });
            var annuityOptionDescriptionDiv = stepContainer.js(jsSelectors.annuityOptionDescriptionDiv, { multiple: true });
            var useMembersAddressCheckbox = stepContainer.js(jsSelectors.useMembersAddressCheckbox);
            var addressContainer = stepContainer.js(jsSelectors.addressContainer);
            var annuitySurvivorSection = stepContainer.js(jsSelectors.annuitySurvivorSection);

            var selectedIndex = annuityOptionRadio.index(annuityOptionRadio.filter(":checked"));
            if (selectedIndex && selectedIndex >= 0) {
                showSelectedAnnuityOptionDescription(selectedIndex);
            }

            var selectedAnnuityOptionKey = annuityOptionRadio.filter(":checked").val();
            if (selectedAnnuityOptionKey && selectedAnnuityOptionKey >= 0) {
                hideShowAnnuitySurvivorSection(selectedAnnuityOptionKey);
            }

            // Handle the annuityOptionRadio click event
            annuityOptionRadio.on("click", function () {

                var selectedIndex = annuityOptionRadio.index(this);
                showSelectedAnnuityOptionDescription(selectedIndex);

                var annuityOptionKey = $(this).val();
                hideShowAnnuitySurvivorSection(annuityOptionKey);
            });

            // Handle useMembersAddressCheckbox changed
            useMembersAddressCheckbox.change(function () {

                var useMembersAddress = useMembersAddressCheckbox.is(":checked");

                visibility.setVisible(addressContainer, !useMembersAddress);
                enableDisableSectionFields(addressContainer, !useMembersAddress)
            });

            // Show (slide down) the description for the selected annuity option
            function showSelectedAnnuityOptionDescription(selectedIndex) {

                // Close all quickly
                annuityOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                annuityOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Helper method to disable all fields in a container
            function enableDisableSectionFields(containerSelector, enabled) {

                // disable all non-hidden inputs in the section
                containerSelector.find("input").not("[type=hidden]").prop("disabled", !enabled).clearErrors();

                // Have to use select helper to disable any selects
                containerSelector.find("select").each(function () {
                    $(this).clearErrors();
                    selectHelper.getHelper($(this)).setDisabled(!enabled);
                });
            }

            // Hide or show annuity survivor section based on the selected annuity option key
            function hideShowAnnuitySurvivorSection(annuityOptionKey) {
                if (annuityOptionKey == 202) {
                    // Close section quickly
                    annuitySurvivorSection.stop(true, true).slideUp(150);
                }
                else {
                    // Slide open section
                    annuitySurvivorSection.stop(true, true).slideDown(150);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);